<template>
<div>
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Conteo de Pedimentos por Aduana y Patente DS" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-dialog v-model="dialog" max-width="600px" style="heigth:'auto'" >
                            <v-card>

                                <v-card-text>
                                    <h5>Aduana - Patente</h5>
                                    <h5 class="caption gray--text font-weight-light" >Seleccione el periodo</h5>
                                    <v-container grid-list-md text-xs-center>
                                        <v-form ref="form1" v-model="valid" lazy-validation>
                                            <v-row no-gutters dense>
                                                <v-col>
                                                    <v-menu offset-x ref="menuA1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field clearable v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[ validaFechas(fecha_de, fecha_a)]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >

                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu1 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col>
                                                    <v-menu offset-x ref="menuA2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field clearable v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fecha_a= parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[ validaFechas(fecha_de, fecha_a)]" ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu2 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                            </v-row>

                                            <v-autocomplete
                                                    v-model="estados"
                                                    :items="items_estados"
                                                    filled
                                                    dense
                                                    chips
                                                    small-chips
                                                    label="Estados de Reconocimiento"
                                                    item-text="clave"
                                                    item-value="clave"
                                                    multiple
                                                    >
                                                   <template v-slot:prepend-item>
                                                    <v-list-item ripple @click="toggle" >
                                                        <v-list-item-action>
                                                            <v-icon :color="estados.length > 0 ? 'indigo darken-4' : ''" >
                                                                {{ icon }}
                                                            </v-icon>
                                                        </v-list-item-action>
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                Seleccionar Todos
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider class="mt-2" ></v-divider>
                                                </template>
                                                <template v-slot:item="data" >
                                                        <template v-if="typeof data.item !== 'object'" >
                                                        <v-list-item-content v-text="data.item" ></v-list-item-content>
                                                        </template>
                                                        <template v-else>
                                                        <v-list-item-content>
                                                            <v-list-item-title v-html="data.item.clave + ' - ' + data.item.nombre" ></v-list-item-title>
                                                        </v-list-item-content>
                                                        </template>
                                                    </template>

                                                    </v-autocomplete>
                                            <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>

                                    <v-spacer></v-spacer>
                                    <v-btn small @click="dialog = false" >Cancelar</v-btn>
                                    <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaGrafica1();" >Consultar</v-btn>

                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <br />

                        <v-tabs grow style="margin-bottom: 30px;" >
                            <v-tabs-slider color="primary" ></v-tabs-slider>
                            <v-tab :key="'in-impo'" >Importaciones</v-tab>
                            <v-tab :key="'in-expo'" >Exportaciones</v-tab>
                           <v-tab :key="'in-inc'" >Reporte Indicadores de Reconocimiento</v-tab>
                            <v-tab-item :key="'in-impo'" style="text-align:center !important;">
                                <div ref="graficas_area1">
                                    <v-row>
                                        <v-col lg="1" style="padding-top:10px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:10px;" >
                                            <h3 class=" mt-2 ml-2" >IMPORTACIONES POR ADUANA</h3>
                                            <div v-if="print" class="d-inline-flex text-right" style=" z-index:1;    width:100%" >
                                                <v-spacer />

                                                <span class="overline secondary--text font-weight-light " >PERIODO: {{fecha_de}} - {{fecha_a}}
                                                    <v-btn small light icon title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
                                                        <v-icon small color="secondary" >mdi-calendar</v-icon>
                                                    </v-btn>

                                                </span>
                                                <exportar-excel :data="data_tableA" :exportFields="data_tableA_excel" name="Importaciones_por_Aduana.xlsx" >
                                                    <v-btn small icon color="green" title="Descargar Información" v-tippy>
                                                        <v-icon dark>mdi-table</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                <v-btn small icon color="red" title="Descargar Gráficas PDF" @click="descargar_graficas(1)" v-tippy>
                                                    <v-icon small>picture_as_pdf</v-icon>
                                                </v-btn>
                                            </div>
                                            <v-client-table style="margin-top:0px;width:100%" ref="vuetableA" :data="data_tableA" :columns="columns_tableA" :options="tableA_options" class="elevation-2 pa-2 footer-hide" >
                                                <template slot="noResults" >
                                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                </template>
                                                <template slot="h__pedimentos_reconocimiento" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos_con_remesas" >
                                                    <div style="font-size:12px" > Remesas <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos" >
                                                    <div style="font-size:12px" > Indicadores <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__pedimentos_alertas" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Alertas </div>
                                                </template>
                                                <template slot="h__alertas" >
                                                    <div style="font-size:12px" > Indicadores <br /> Alertas </div>
                                                </template>
                                                <div slot="aduana" slot-scope="props" class="text-center" >
                                                    <a v-if="props.row.aduana!='TOTAL'" :title="nombre_aduana(props.row.aduana)" @click="porPatente(props.row.aduana, props.row.tipo_operacion)" v-tippy>{{props.row.aduana}}</a>
                                                    <b v-if="props.row.aduana=='TOTAL'" >{{props.row.aduana}}</b>
                                                </div>
                                                <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                                <div slot="remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.remesas)}}</div>
                                                <div slot="reconocimientos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos)}}</div>
                                                <div slot="alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.alertas)}}</div>
                                                <div slot="rectificacion" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificacion)}}</div>
                                                <div slot="pedimentos_reconocimiento" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_reconocimiento)}}</div>
                                                <div slot="reconocimientos_con_remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos_con_remesas)}}</div>
                                                <div slot="pedimentos_alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_alertas)}}</div>
                                            </v-client-table>

                                        </v-col>
                                    </v-row>
                                    <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >
                                        <v-col lg="1" style="padding-top:10px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:0px;" >
                                            <div id="grafica1" >
                                                <base-material-chart-card :options="data_grafica1" color="white" type="Bar" >
                                                    <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>
                                                </base-material-chart-card>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col lg="1" style="padding-top:10px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:10px;" >
                                            <div id="grafica3" v-if="data_tableC.length>0 && print" >
                                                <h5 class="card-title font-weight-light mt-2 ml-2" >DETALLE POR PATENTE</h5>
                                                <v-card-actions style="padding:0; height:0px; margin-top:-28px" >
                                                    <v-spacer></v-spacer>

                                                    <v-btn color="black" icon title="Ocultar Tabla" @click="ocultaImpo()" v-tippy>
                                                        <v-icon dark>mdi-close</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </div>
                                            <br />
                                            <div v-if="data_tableC.length>0" class="d-inline-flex text-right" style=" z-index:1; width:100%; padding-right:10px;" >
                                                <h5>{{titulo_detalle}}</h5>
                                                <v-spacer />
                                                <exportar-excel v-if="print" :data="data_tableC" :exportFields="data_tableC_excel" name="Importaciones_por_Patente.xlsx" >
                                                    <v-btn x-small icon color="green" title="Descargar Información" v-tippy>
                                                        <v-icon dark>mdi-table</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                            </div>

                                            <v-client-table v-if="data_tableC.length>0" style="margin-top:0px; min-heigth:300px;" ref="vuetableA" :data="data_tableC" :columns="columns_tableC" :options="tableC_options" class="elevation-2 pa-2 footer-hide" >
                                                <template slot="noResults" >
                                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                </template>
                                                <template slot="h__pedimentos_reconocimiento" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos_con_remesas" >
                                                    <div style="font-size:12px" > Remesas <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos" >
                                                    <div style="font-size:12px" > Indicadores <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__pedimentos_alertas" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Alertas </div>
                                                </template>
                                                <template slot="h__alertas" >
                                                    <div style="font-size:12px" > Indicadores <br /> Alertas </div>
                                                </template>
                                                <div slot="patente" slot-scope="props" class="text-end" :class="props.row.patente=='TOTAL'?'font-weight-black':''" >{{props.row.patente}}</div>
                                                <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                                <div slot="remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.remesas)}}</div>
                                                <div slot="reconocimientos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos)}}</div>
                                                <div slot="alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.alertas)}}</div>
                                                <div slot="rectificacion" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificacion)}}</div>
                                                <div slot="pedimentos_reconocimiento" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_reconocimiento)}}</div>
                                                <div slot="reconocimientos_con_remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos_con_remesas)}}</div>
                                                <div slot="pedimentos_alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_alertas)}}</div>
                                            </v-client-table>

                                        </v-col>
                                    </v-row>
                                    <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >
                                        <v-col lg="1" style="padding-top:0px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:0px;" >
                                            <div id="grafica3" v-if="data_tableC.length>0" style="margin-top:0px;" >
                                                <base-material-chart-card :options="data_grafica3" color="white" type="Bar" >
                                                    <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>
                                                </base-material-chart-card>

                                            </div>
                                        </v-col>
                                    </v-row>

                                </div>
                            </v-tab-item>
                            <v-tab-item :key="'in-expo'" style="text-align:center !important;">
                                <div ref="graficas_area2" >
                                    <v-row>
                                        <v-col lg="1" style="padding-top:0px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:0px;" >
                                            <h3 class=" mt-2 ml-2" >EXPORTACIONES POR ADUANA</h3>
                                            <div v-if="print" class="d-inline-flex text-right" style=" z-index:1;    width:100%" >
                                                <v-spacer />
                                                <span class="overline secondary--text font-weight-light " >PERIODO: {{fecha_de}} - {{fecha_a}}
                                                    <v-btn small light icon title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
                                                        <v-icon small color="secondary" >mdi-calendar</v-icon>
                                                    </v-btn>

                                                </span>
                                                <exportar-excel :data="data_tableB" :exportFields="data_tableB_excel" name="Exportaciones_por_Aduana.xlsx" >
                                                    <v-btn small icon color="green" title="Descargar Información" v-tippy>
                                                        <v-icon dark>mdi-table</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                <v-btn small icon color="red" title="Descargar Gráficas PDF" @click="descargar_graficas(2)" v-tippy>
                                                    <v-icon small>mdi-file-pdf </v-icon>
                                                </v-btn>
                                            </div>

                                            <v-client-table style="margin-top:0px;" ref="vuetableB" :data="data_tableB" :columns="columns_tableB" :options="tableB_options" class="elevation-2 pa-2 footer-hide" >
                                                <template slot="noResults" >
                                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                </template>
                                                <template slot="h__pedimentos_reconocimiento" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos_con_remesas" >
                                                    <div style="font-size:12px" > Remesas <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos" >
                                                    <div style="font-size:12px" > Indicadores <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__pedimentos_alertas" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Alertas </div>
                                                </template>
                                                <template slot="h__alertas" >
                                                    <div style="font-size:12px" > Indicadores <br /> Alertas </div>
                                                </template>
                                                <div slot="aduana" slot-scope="props" class="text-center" >
                                                    <a v-if="props.row.aduana!='TOTAL'" :title="nombre_aduana(props.row.aduana)" @click="porPatente(props.row.aduana, props.row.tipo_operacion)" v-tippy>{{props.row.aduana}}</a>
                                                    <b v-if="props.row.aduana=='TOTAL'" >{{props.row.aduana}}</b>
                                                </div>
                                                <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                                <div slot="remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.remesas)}}</div>
                                                <div slot="reconocimientos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos)}}</div>
                                                <div slot="alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.alertas)}}</div>
                                                <div slot="rectificacion" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificacion)}}</div>
                                                <div slot="pedimentos_reconocimiento" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_reconocimiento)}}</div>
                                                <div slot="reconocimientos_con_remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos_con_remesas)}}</div>
                                                <div slot="pedimentos_alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_alertas)}}</div>

                                            </v-client-table>
                                        </v-col>
                                    </v-row>
                                    <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >
                                        <v-col lg="1" style="padding-top:0px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:0px;" >
                                            <div id="grafica2" >
                                                <base-material-chart-card :options="data_grafica2" color="white" type="Bar" >
                                                    <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>
                                                </base-material-chart-card>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col lg="1" style="padding-top:0px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:60px;" >
                                            <div id="grafica3" v-if="data_tableD.length>0 && print" >
                                                <h5 class="card-title font-weight-light mt-2 ml-2" >DETALLE POR PATENTE</h5>
                                                <v-card-actions style="padding:0; height:0px; margin-top:-38px" >
                                                    <v-spacer></v-spacer>

                                                    <v-btn color="black" icon title="Ocultar Tabla" @click="ocultaExpo()" v-tippy>
                                                        <v-icon dark>mdi-close</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </div>
                                            <br />
                                            <div v-if="data_tableD.length>0" class="d-inline-flex text-right" style=" z-index:1;    width:100%; padding-right:10px;" >
                                                <h5>{{titulo_detalle}}</h5>
                                                <v-spacer />
                                                <exportar-excel v-if="print" :data="data_tableB" :exportFields="data_tableD_excel" name="Exportaciones_por_Patente.xlsx" >
                                                    <v-btn x-small icon color="green" title="Descargar Información" v-tippy>
                                                        <v-icon dark>mdi-table</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                            </div>

                                            <v-client-table v-if="data_tableD.length>0" style="margin-top:0px;" ref="vuetableA" :data="data_tableD" :columns="columns_tableD" :options="tableD_options" class="elevation-2 pa-2 footer-hide" >
                                                <template slot="noResults" >
                                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                </template>
                                                <template slot="h__pedimentos_reconocimiento" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos_con_remesas" >
                                                    <div style="font-size:12px" > Remesas <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__reconocimientos" >
                                                    <div style="font-size:12px" > Indicadores <br /> Reconocimiento </div>
                                                </template>
                                                <template slot="h__pedimentos_alertas" >
                                                    <div style="font-size:12px" > Pedimentos <br /> Alertas </div>
                                                </template>
                                                <template slot="h__alertas" >
                                                    <div style="font-size:12px" > Indicadores <br /> Alertas </div>
                                                </template>
                                                <div slot="patente" slot-scope="props" class="text-end" :class="props.row.patente=='TOTAL'?'font-weight-black':''" >{{props.row.patente}}</div>
                                                <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                                <div slot="remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.remesas)}}</div>
                                                <div slot="reconocimientos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos)}}</div>
                                                <div slot="alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.alertas)}}</div>
                                                <div slot="rectificacion" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificacion)}}</div>
                                                <div slot="pedimentos_reconocimiento" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_reconocimiento)}}</div>
                                                <div slot="reconocimientos_con_remesas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.reconocimientos_con_remesas)}}</div>
                                                <div slot="pedimentos_alertas" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos_alertas)}}</div>
                                            </v-client-table>
                                        </v-col>
                                    </v-row>
                                    <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >
                                        <v-col lg="1" style="padding-top:0px;" >
                                        </v-col>
                                        <v-col lg="10" style="padding-top:0px;" >
                                            <div id="grafica4" v-if="data_tableD.length>0" >
                                                <base-material-chart-card :options="data_grafica4" color="white" type="Bar" >
                                                    <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>
                                                </base-material-chart-card>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-tab-item>
                            <v-tab-item :key="'in-inc'" >
                                <indicadores ref="incrementables" ></indicadores>
                            </v-tab-item>
                        </v-tabs>

                        <br /><br /><br /><br />

                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
var colors_bars = [
    "green",
    "#ffde17", //amarillo
    "#eb7601", //naranja
    "lime",
    "blue",
];
import axios from "axios";
import moment from "moment";
import Canvg from 'canvg';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import indicadores from "@/views/graficas/ReporteIndicadoresEstadoDS";

window.html2canvas = html2canvas

export default {
    name: "DashboardDashboard",
    watch: {

    },
    components: {
        indicadores,
    },
    data() {
        return {
           estados: ["310", "320", "410", "450", "460"],

          //  estados: ["310", "330", "340", "410", "415", "420", "430", "440", "450", "460", "480", "481", "482", "490", "491", "510", "520", "530", "610", "620", "630", "720", "750", "760"],
            items_estados: [
                            {clave:'310',  nombre:'RECONOCIMIENTO ADUANERO'},
                             {clave:'320',  nombre:'DESADUANAMIENTO LIBRE'},

                       //     {clave:'330',  nombre:'INVESTIGACIÓN'},
                        //    {clave:'340',  nombre:'PEDIMENTO EMBARGADO'},
                            {clave:'410',  nombre:'INICIO FISICO-DOCUMENTAL'},
                         //   {clave:'415',  nombre:'TOMA DE MUESTRA'},
                        //    {clave:'420',  nombre:'PENDIENTE POR MANIOBRAS'},
                         //   {clave:'430',  nombre:'PENDIENTE DOCUMENTACIÓN AUXILIAR'},
                        //    {clave:'440',  nombre:'PENDIENTE DOCUMENTACIÓN OFICIAL'},
                            {clave:'450',  nombre:'SIN INCIDENCIAS'},
                            {clave:'460',  nombre:'CON INCIDENCIA'},
                        //    {clave:'480',  nombre:'INICIO GAMMA'},
                        //    {clave:'481',  nombre:'R=GAMMA CORRECTO'},
                        //    {clave:'482',  nombre:'R= GAMMA DIFUSO'},
                        //    {clave:'490',  nombre:'INICIO RNI'},
                        //    {clave:'491',  nombre:'R=SIN INCIDENCIAS'},
                        //    {clave:'510',  nombre:'SEGUNDO RECONOCIMIENTO'},
                        //    {clave:'520',  nombre:'DESADUANAMIENTO LIBRE'},
                      //      {clave:'530',  nombre:'INVESTIGACIÓN'},
                       //     {clave:'610',  nombre:'INICIO RECONOCIMIENTO'},
                        //    {clave:'620',  nombre:'R=SIN INCIDENCIAS'},
                        //    {clave:'630',  nombre:'R=CON INCIDENCIAS'},
                      //      {clave:'720',  nombre:'INVESTIGACIÓN EN GARITA'},
                       //     {clave:'750',  nombre:'DESISTIDO'},
                       //     {clave:'760',  nombre:'RECTIFICADO'}
                        ],
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Reportes",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Aduana - Patente WS",
                    disabled: true,
                    to: ""
                }
            ],
            print: true,
            titulo_detalle: "",
            valid: true,
            loader: null,
            loading: false,
            dialog: false,
            consultaG1: "",
            data_patentes: [],
            dialog1: false,

            menu1: false,
            menu2: false,
            fecha_de: "",
            fecha_a: "",
            a1: 2020,
            lista_aduanas: [],
            data_grafica1: {
               /*  chart: {
                    type: "spline",
                    backgroundColor: '#fff',
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                }, */
                 chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 1,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 1,
                    minorGridLineWidth: 1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal",
                        minPointLength: 2
                    },
                    series: {

                        showInLegend: false
                    }
                },
                legend: {
                    enabled: false
                },
                series: []
            },
            data_grafica2: {
             /*    chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                }, */
                 chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 1,
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 1,
                    minorGridLineWidth: 1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal",
                        minPointLength: 2
                    }
                },
                legend: {
                    enabled: false
                },
                series: [

                ]
            },
            data_grafica3: {
                chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    },
                },

                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 1,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 1,
                    minorGridLineWidth: 1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal",
                        minPointLength: 2
                    },
                    series: {
                        showInLegend: true,
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}'
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                series: []
            },
            data_grafica4: {
                chart: {
                    type: "column",
                    backgroundColor: null,
                    height: 250,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 1,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 1,
                    minorGridLineWidth: 1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal",
                        minPointLength: 2
                    },
                    series: {
                        showInLegend: true
                    }
                },
                legend: {
                    enabled: false
                },
                series: []
            },

            data_tableA: [],
            data_tableB: [],
            data_tableC: [],
            data_tableD: [],

            columns_tableA: [
                "aduana",
                "pedimentos",
                "rectificacion",
                "remesas",
                "pedimentos_reconocimiento",
                "reconocimientos_con_remesas",
                "reconocimientos",
                "pedimentos_alertas",

            ],
            tableA_options: {
                filterable: false,
                filterByColumn: false,
                sortable: [],
                perPage: 100,
                texts: {
                    count: ''
                },
                headings: {
                    "aduana": "Aduana",
                    "pedimentos": "Pedimentos",
                    "rectificacion": "Rectificaciones",
                    "remesas": "Remesas",
                    "pedimentos_reconocimiento": "Pedimentos Reconocimiento",
                    "reconocimientos_con_remesas": "Remesas Reconocimiento",
                    "reconocimientos": "Indicadores Reconocimiento",
                    "pedimentos_alertas": "Pedimentos Alertas",

                }
            },
            data_tableA_excel: {
                "Aduana": "aduana",
                "Pedimentos": "pedimentos",
                "Rectificaciones": "rectificacion",
                "Remesas": "remesas",
                "Pedimentos Reconocimiento": "pedimentos_reconocimiento",
                "Remesas Reconocimiento": "reconocimientos_con_remesas",
                "Indicadores Reconocimiento": "reconocimientos",
                "Pedimentos Alertas": "pedimentos_alertas",

            },
            columns_tableB: [
                "aduana",
                "pedimentos",
                "rectificacion",
                "remesas",
                "pedimentos_reconocimiento",
                "reconocimientos_con_remesas",
                "reconocimientos",
                "pedimentos_alertas",

            ],
            tableB_options: {
                filterable: false,
                filterByColumn: false,
                sortable: [],
                perPage: 100,
                headings: {
                    "aduana": "Aduana",
                    "pedimentos": "Pedimentos",
                    "rectificacion": "Rectificaciones",
                    "remesas": "Remesas",
                    "pedimentos_reconocimiento": "Pedimentos Reconocimiento",
                    "reconocimientos_con_remesas": "Remesas Reconocimiento",
                    "reconocimientos": "Indicadores Reconocimiento",
                    "pedimentos_alertas": "Pedimentos Alertas",

                }
            },
            data_tableB_excel: {
                "Aduana": "aduana",
                "Pedimentos": "pedimentos",
                "Rectificaciones": "rectificacion",
                "Remesas": "remesas",
                "Pedimentos Reconocimiento": "pedimentos_reconocimiento",
                "Remesas Reconocimiento": "reconocimientos_con_remesas",
                "Indicadores Reconocimiento": "reconocimientos",
                "Pedimentos Alertas": "pedimentos_alertas",
            },
            columns_tableC: [
                "patente",
                "pedimentos",
                "rectificacion",
                "remesas",
                "pedimentos_reconocimiento",
                "reconocimientos_con_remesas",
                "reconocimientos",
                "pedimentos_alertas",

            ],
            tableC_options: {
                filterable: false,
                perPage: 100,
                sortable: [],
                filterByColumn: false,
                headings: {
                    "patente": "Patente",
                    "pedimentos": "Pedimentos",
                    "rectificacion": "Rectificaciones",
                    "pedimentos_reconocimiento": "Pedimentos Reconocimiento",
                    "reconocimientos_con_remesas": "Remesas Reconocimiento",
                    "reconocimientos": "Indicadores Reconocimiento",
                    "pedimentos_alertas": "Pedimentos Alertas",

                }
            },
            data_tableC_excel: {
                "Patente": "patente",
                "Pedimentos": "pedimentos",
                "Rectificaciones": "rectificacion",
                "Pedimentos Reconocimiento": "pedimentos_reconocimiento",
                "Remesas Reconocimiento": "reconocimientos_con_remesas",
                "Indicadores Reconocimiento": "reconocimientos",
                "Pedimentos Alertas": "pedimentos_alertas",

            },
            columns_tableD: [
                "patente",
                "pedimentos",
                "rectificacion",
                "remesas",
                "pedimentos_reconocimiento",
                "reconocimientos_con_remesas",
                "reconocimientos",
                "pedimentos_alertas",

            ],
            tableD_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                sortable: [],
                headings: {
                    "patente": "Patente",
                    "pedimentos": "Pedimentos",
                    "rectificacion": "Rectificaciones",
                    "pedimentos_reconocimiento": "Pedimentos Reconocimiento",
                    "reconocimientos_con_remesas": "Remesas Reconocimiento",
                    "reconocimientos": "Indicadores Reconocimiento",
                    "pedimentos_alertas": "Pedimentos Alertas",

                },

            },

            data_tableD_excel: {
                "Patente": "patente",
                "Pedimentos": "pedimentos",
                "Rectificaciones": "rectificacion",
                "Pedimentos Reconocimiento": "pedimentos_reconocimiento",
                "Remesas Reconocimiento": "reconocimientos_con_remesas",
                "Indicadores Reconocimiento": "reconocimientos",
                "Pedimentos Alertas": "pedimentos_alertas",
            },

        };
    },

    computed: {
        likesAll() {
            return this.estados.length === this.items_estados.length
        },
        likesSome() {
            return this.estados.length > 0 && !this.likesAll
        },
        icon() {
            if (this.likesAll) return 'mdi-close-box'
            if (this.likesSome) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },

    },
    mounted() {

    },
    async created() {

        var f_de = new Date();
        var f_a = new Date();

        f_de.setDate(f_de.getDate() - 7);

        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();

        let y_de = f_de.getFullYear();

        if (m < 10)
            m = '0' + m;
        if (d < 10)
            d = '0' + d;

        let fecha_a = y + "-" + m + "-" + d;
        let fecha_de = y_de + "-01-01";
        this.fecha_a = fecha_a;
        this.fecha_de = fecha_de;
        this.llenaraduanas();
        await this.estadisticaGrafica1();

    },
    methods: {
        toggle() {
            this.$nextTick(() => {
                if (this.likesAll) {
                    this.estados = []
                } else {
                    this.estados = this.items_estados.slice()
                }
            })
        },
        ocultaExpo() {
            this.data_tableD = [];
        },
        ocultaImpo() {
            this.data_tableC = [];
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
        filterResult() {
            Event.$emit('vue-tables.filter::filtro', this.filtro);
        },
        complete(index) {
            this.list[index] = !this.list[index];
        },
        nombre_aduana(aduana) {

            let r = this.lista_aduanas.filter(data => data.clave == aduana);

            if (r.length > 0)
                return r[0].nombre;
            else
                return "";
        },
        porPatente(aduana, tipo) {
            this.data_tableC = [];
            this.data_tableD = [];
            this.titulo_detalle = aduana + " - " + this.nombre_aduana(aduana);
            let r = this.data_patentes.filter(data => data.aduana == aduana && data.tipo_operacion == tipo);
            let patentes = [];
            let pedimentos = [];
            let remesas = [];
            let reconocimientos = [];
            let alertas = [];
            let rectificaciones = [];
            let data = [];
            r = r.sort(function (a, b) {
                return a.patente - b.patente;
            });
            let Itpe = 0;
            let Itre = 0;
            let Itra = 0;
            let Ital = 0;
            let Itrc = 0;
            r.forEach(
                function (item) {

                    patentes.push(item.patente);
                    pedimentos.push(item.pedimentos);
                   remesas.push(item.remesas);
                    reconocimientos.push(item.pedimentos_reconocimiento);
                    alertas.push(item.pedimentos_alertas);
                    rectificaciones.push(item.rectificacion);
                    data.push(item);
                    Itpe += item.pedimentos;
                    Itre += item.remesas;
                    Itra += item.pedimentos_reconocimiento;
                    Ital += item.pedimentos_alertas;
                    Itrc += item.rectificacion;

                }
            );
            /*   data.push({
                          'tipo_operacion':tipo,
                          'patente':"TOTAL",
                          'pedimentos':Itpe,
                           'remesas': Itre,
                            'reconocimientos': Itra,
                             'alertas': Ital,
                              'rectificacion':  Itrectificacion
                      }); */

            if (tipo == "Importaciones") {
                this.data_grafica3.xAxis.categories = patentes;
                this.data_grafica3.series[0] = {
                    "name": "Pedimentos",
                    "data": pedimentos,
                    "stack": "Pedimentos"
                };

            /*     this.data_grafica3.series[1] = {
                    "name": "Remesas",
                    "data": remesas,
                    "stack": "Remesas"
                }; */
                this.data_grafica3.series[1] = {
                    "name": "Reconocimiento",
                    "data": reconocimientos,
                    "stack": "Reconocimiento"
                };
                this.data_grafica3.series[2] = {
                    "name": "Alertas en Reconocimiento",
                    "data": alertas,
                    "stack": "Alertas"
                };
                this.data_grafica3.series[3] = {
                    "name": "rectificaciones",
                    "data": rectificaciones,
                    "stack": "rectificacion"
                };
                this.data_tableC = data;
            } else {
                this.data_grafica4.xAxis.categories = patentes;
                this.data_grafica4.series[0] = {
                    "name": "Pedimentos",
                    "data": pedimentos,
                    "stack": "Pedimentos"
                };

               /*  this.data_grafica4.series[1] = {
                    "name": "Remesas",
                    "data": remesas,
                    "stack": "Remesas"
                }; */
                this.data_grafica4.series[1] = {
                    "name": "Reconocimiento",
                    "data": reconocimientos,
                    "stack": "Reconocimiento"
                };
                this.data_grafica4.series[2] = {
                    "name": "Alertas en Reconocimiento",
                    "data": alertas,
                    "stack": "Alertas"
                };
                this.data_grafica4.series[3] = {
                    "name": "Rectificaciones",
                    "data": rectificaciones,
                    "stack": "rectificaciones"
                };
                this.data_tableD = data;
            }

        },
        async estadisticaGrafica1() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.data_patentes = [];
            this.data_tableC = [];
            this.data_tableD = [];
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "fecha_de": this.fecha_de,
                "fecha_a": this.fecha_a,
                "patente": false,
                "estados": this.estados
            }
            await axios.post(this.$hostname + 'reportes/pedimentos_aduana_patente_ds/', datos)
                .then(async (response) => {
                    var datos_p = {
                        "rfc": this.$local_storage.get("rfc"),
                        "fecha_de": this.fecha_de,
                        "fecha_a": this.fecha_a,
                        "patente": true,
                        "estados": this.estados
                    }
                    let self = this
                    await axios.post(this.$hostname + 'reportes/pedimentos_aduana_patente_ds/', datos_p)
                        .then((response) => {
                            let rp = response.data;
                            rp = rp.sort(function (a, b) {
                                return a.patente - b.patente;
                            });
                            self.data_patentes = rp;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                    let r = response.data;
                    let aduanas_impo = [];
                    let pedimentos_impo = [];
                    let remesas_impo = [];
                    let reconocimientos_impo = [];
                    let alertas_impo = [];
                    let re_impo = [];
                    let aduanas_expo = [];
                    let pedimentos_expo = [];
                    let remesas_expo = [];
                    let reconocimientos_expo = [];
                    let alertas_expo = [];
                    let re_expo = [];
                    let impos = [];
                    let expos = [];
                    r = r.sort(function (a, b) {
                        return a.aduana - b.aduana;
                    });
                    let Itpe = 0;
                    let Itre = 0;
                    let Itra = 0;
                    let Ital = 0;
                    let Itrc = 0;
                    let Itpere = 0;
                    let Itrere = 0;
                    let Itpeal = 0;
                    let Etpe = 0;
                    let Etre = 0;
                    let Etra = 0;
                    let Etal = 0;
                    let Etrc = 0;
                    let Etpere = 0;
                    let Etrere = 0;
                    let Etpeal = 0;
                    r.forEach(
                        function (item) {
                            if (item.tipo_operacion == "Importaciones") {
                                aduanas_impo.push(item.aduana);
                                pedimentos_impo.push(item.pedimentos);
                                remesas_impo.push(item.remesas);
                                reconocimientos_impo.push(item.pedimentos_reconocimiento);
                                alertas_impo.push(item.pedimentos_alertas);
                                re_impo.push(item.rectificacion);

                                Itpe += item.pedimentos;
                                Itre += item.remesas;
                                Itra += item.reconocimientos;
                                Ital += item.alertas;
                                Itrc += item.rectificacion;
                                Itpere += item.pedimentos_reconocimiento;
                                Itrere += item.reconocimientos_con_remesas;
                                Itpeal += item.pedimentos_alertas;

                                impos.push(item);
                            }
                            if (item.tipo_operacion == "Exportaciones") {
                                aduanas_expo.push(item.aduana);
                                pedimentos_expo.push(item.pedimentos);
                                remesas_expo.push(item.remesas);
                                reconocimientos_expo.push(item.pedimentos_reconocimiento);
                                alertas_expo.push(item.pedimentos_alertas);
                                re_expo.push(item.rectificacion);

                                Etpe += item.pedimentos;
                                Etre += item.remesas;
                                Etra += item.reconocimientos;
                                Etal += item.alertas;
                                Etrc += item.rectificacion;
                                Etpere += item.pedimentos_reconocimiento;
                                Etrere += item.reconocimientos_con_remesas;
                                Etpeal += item.pedimentos_alertas;

                                expos.push(item);
                            }

                        }
                    );
                    impos.push({
                        'tipo_operacion': "Importación",
                        'aduana': "TOTAL",
                        'pedimentos': Itpe,
                        'remesas': Itre,
                        'reconocimientos': Itra,
                        'alertas': Ital,
                        'rectificacion': Itrc,
                        'pedimentos_reconocimiento': Itpere,
                        'reconocimientos_con_remesas': Itrere,
                        'pedimentos_alertas': Itpeal
                    });
                    expos.push({
                        'tipo_operacion': "Exportación",
                        'aduana': "TOTAL",
                        'pedimentos': Etpe,
                        'remesas': Etre,
                        'reconocimientos': Etra,
                        'alertas': Etal,
                        'rectificacion': Etrc,
                        'pedimentos_reconocimiento': Etpere,
                        'reconocimientos_con_remesas': Etrere,
                        'pedimentos_alertas': Etpeal
                    });
                    this.data_grafica1.xAxis.categories = aduanas_impo;
                    this.data_grafica1.series[0] = {
                        "name": "Pedimentos",
                        "data": pedimentos_impo,
                        "stack": "Pedimentos"
                    };

                  /*   this.data_grafica1.series[1] = {
                        "name": "Remesas",
                        "data": remesas_impo,
                        "stack": "Remesas"
                    }; */
                    this.data_grafica1.series[1] = {
                        "name": "Reconocimiento",
                        "data": reconocimientos_impo,
                        "stack": "Reconocimiento"
                    };
                    this.data_grafica1.series[2] = {
                        "name": "Alertas en Reconocimiento",
                        "data": alertas_impo,
                        "stack": "Alertas"
                    };
                    this.data_grafica1.series[3] = {
                        "name": "rectificaciones",
                        "data": re_impo,
                        "stack": "rectificaciones"
                    };
                    this.data_grafica2.xAxis.categories = aduanas_expo;
                    this.data_grafica2.series[0] = {
                        "name": "Pedimentos",
                        "data": pedimentos_expo,
                        "stack": "Pedimentos"
                    };

                    // this.data_grafica2.series[1] = {
                    //     "name": "Remesas",
                    //     "data": remesas_expo,
                    //     "stack": "Remesas"
                    // };
                    this.data_grafica2.series[1] = {
                        "name": "Reconocimiento",
                        "data": reconocimientos_expo,
                        "stack": "Reconocimiento"
                    };
                    this.data_grafica2.series[2] = {
                        "name": "Alertas",
                        "data": alertas_expo,
                        "stack": "Alertas"
                    };
                    this.data_grafica2.series[3] = {
                        "name": "rectificaciones",
                        "data": re_expo,
                        "stack": "rectificaciones"
                    };
                    this.data_tableA = impos;
                    this.data_tableB = expos;

                })
                .catch((error) => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog = false;
                    this.loader = null;
                    this.loading = false;
                });
        },

        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna."
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna."
            }
            return true;
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        descargar_graficas: function () {
            let area = this.$refs["graficas_area"]
            var pdf = new jsPDF('l', 'pt');

            html2canvas(area, {
                width: 1700,
                height: 800,
                scale: 0.85,
                dpi: 300,
                logging: true,
                removeContainer: false
            }).then(function (canvas) {
                //   pdf.setFontSize(20);
                // pdf.text(360, 80, 'Gráficas')
                pdf.addImage(canvas, 'PNG', 10, 10);
                pdf.save('graficas.pdf');
            });

        },
        llenaraduanas() {

            axios.get(this.$hostname + 'catalogos/aduanas/')
                .then((response) => {
                    this.lista_aduanas = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async descargar_graficas(tipo) {
            this.print = false;
            var pdf = new jsPDF('l', 'pt');
            var el = ""
            var name = "";
            var alto = 260;
            if (tipo == 1) {
                el = this.$refs.graficas_area1;
                name = "Aduana_Patente_Importaciones_DS.pdf";
                if (this.data_tableC.length > 0)
                    alto = 520;
            } else {
                el = this.$refs.graficas_area2;
                name = "Aduana_Patente_Exportaciones_WS.pdf";
                if (this.data_tableD.length > 0)
                    alto = 520;
            }

            const options = {
                type: 'dataURL'
            }
            var url = await this.$html2canvas(el, options);

            pdf.setFontSize(20);
            pdf.addImage(url, 'PNG', 20, 80, 800, alto);
            pdf.save(name);
            this.print = true;

        },

    }
};
</script>

<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>
